module.exports = __webpack_public_path__ + "media/images/logo-a33e3265dabf8dc4b520d26d711967e0.png";